import { Exclude, Type } from "class-transformer";
import { CategoryType } from "./ShopItem";
import { getItemCategoryI18N, getShopItemCategoryI18N } from "../utils/itemcategories";
import { SalesManagerShopItemCategory } from "@impacgroup/ayyildiz-checklist-platform-api-dtos";

export class OrderItem {
    _id?: string;

    @Type(() => UserObj)
    user?: UserObj;

    itemCount?: number;

    @Type(() => Date)
    @Exclude({ toPlainOnly: true })
    created?: Date;
}

export class OrderDetails {
    @Type(() => UserObj)
    user?: UserObj;

    @Type(() => OrderPositionObj)
    orderPositions?: OrderPositionObj;

    @Type(() => Date)
    @Exclude({ toPlainOnly: true })
    created?: Date;
}

class UserObj {
    firstname?: string;
    lastname?: string;
    email?: string;
    street?: string;
    postcode?: string;
    city?: string;

    public formatUser(): string {
        return `${this.firstname ? `${this.firstname} ` : ""}\
        ${this.lastname ? `${this.lastname} ` : ""}\
        ${this.firstname || this.lastname ? "\r\n" : ""}\
        ${this.email ? `${this.email} ` : ""}\
        ${this.street ? "\r\n" + this.street : ""}\
        ${this.postcode ? "\r\n" + this.postcode : ""}\
        ${this.city ? " " + this.city : ""}`;
    }

    public htmlFormatUser(): string {
        return this.formatUser().replace(/(?:\r\n|\r|\n)/g, "<br />");
    }
}

class OrderPositionObj {
    item?: {
        materialNumber?: string;
        name?: string;
        category?: CategoryType | SalesManagerShopItemCategory;
    };
    quantity?: number;

    public getCategoryI18N(): string {
        return getItemCategoryI18N(this.item.category);
    }
}
